import script from "./TestDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./TestDetail.vue?vue&type=script&setup=true&lang=js"

import "./TestDetail.vue?vue&type=style&index=0&id=a9e65bc6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tests-frontend/tests-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9e65bc6"]])

export default __exports__